import React from 'react';

export const DiffContext = React.createContext({});
